module.exports = __webpack_public_path__ + "img/img1.5f4dd4a2.jpg";